import { cva, VariantProps } from 'class-variance-authority'
import Button, { ButtonProps, LinkButton, LinkButtonProps } from 'components/core/button'
import { cn } from 'lib/util/cn'
import { LucideIcon } from 'lucide-react'

interface StateScreenProps extends IconWrapperProps {
  Icon: LucideIcon
  title: string
  subTitle?: string
  buttons?: Array<
    | ({ text: string; Icon?: LucideIcon; url?: string } & LinkButtonProps)
    | ({ text: string; Icon?: LucideIcon } & ButtonProps)
  >
  className?: string
}

const iconWrapper = cva('tw-rounded-md tw-p-2', {
  variants: {
    color: {
      warning: 'tw-bg-sunnyyellow-50 tw-text-sunnyyellow-800',
      error: 'tw-bg-flushpink-50 tw-text-flushpink-500',
      neutral: 'tw-bg-neutral-50 tw-text-neutral-500',
    },
  },
  defaultVariants: {
    color: 'neutral',
  },
})
type IconWrapperProps = VariantProps<typeof iconWrapper>

export const StateScreen = ({ Icon, title, subTitle, buttons, className, color }: StateScreenProps) => {
  return (
    <div className={cn('tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-2 tw-text-center', className)}>
      <div className={iconWrapper({ color })}>
        <Icon className="lu-xl" />
      </div>
      <div className="tw-text-sm tw-font-bold tw-text-neutral-800">{title}</div>
      <div className="tw-max-w-prose tw-text-neutral-500">{subTitle}</div>

      <div className="tw-flex tw-flex-row tw-gap-2">
        {buttons?.map(({ Icon, text, ...button }) => {
          if ('url' in button) {
            return (
              <LinkButton color="neutral" key={text} {...button} className={cn('tw-flex tw-flex-row tw-items-center')}>
                {Icon && <Icon className="tw-mr-2 tw-min-h-5 tw-min-w-5" />}
                {text}
              </LinkButton>
            )
          }

          return (
            <Button color="neutral" key={text} {...button} className={cn('tw-flex tw-flex-row tw-items-center')}>
              {Icon && <Icon className="tw-mr-2 tw-min-h-5 tw-min-w-5" />}
              {text}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
